import { z } from 'zod'

export let seriesFormSchema = z.object({
  linkedServiceID: z.string().nonempty('Linked service is required'),
  name: z.string().nonempty('Name is required'),
  description: z.string().nonempty('Description is required'),
})
